import React, { FC } from 'react'

import { IconHelpCircleProps } from './IconHelpCircle.types'
import * as Styled from './styles/IconHelpCircle.style'

import { nonThemeableRules } from '../../ruleSet'

const IconHelpCircle: FC<IconHelpCircleProps> = ({
  size = nonThemeableRules.defaultSize as number as IconHelpCircleProps['size'],
  isResponsive = false,
}: IconHelpCircleProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18.97 17.573s.683-3.653 5.03-3.633c4.348.02 5.817 5.355 3.525 7.688A141.394 141.394 0 0 1 25 24.142a3.364 3.364 0 0 0-1 2.396v1.932'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24 35a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' fill='#E60000' />
        <path
          d='M24 34.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconHelpCircle
